import React from 'react';

import BlockInputSection from './BlockInputSection';

type TBaseProps = Parameters<typeof BlockInputSection>[0];

type Props = {
  title: TBaseProps['title'];
  inputs: TBaseProps['inputs'];
};

export default function createBlockInputSection({ title, inputs }: Props) {
  return ({ name }: { name: string }) => <BlockInputSection title={title} inputs={inputs} name={name} />;
}
